import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, TextField, Snackbar, Alert, CircularProgress } from '@mui/material';
import axios from 'axios'
import { TbLoader } from 'react-icons/tb';
import { MdOutlineRefresh } from "react-icons/md";

const useStyles = makeStyles((theme)=>({

  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  smsBasicBlockH1:{
    padding:'40px 0 20px 0px',
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  innerDiv:{
    margin:'20px 0',
    display:'flex',
    alignItems:'center',
    paddingBottom:'20px',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'250px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center',
    }
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
  },
  secondH1:{
    padding:'50px 0'
  },
  formTextarea:{
    width:'100%',
    height:'200px',
    background:'#DEDEDE',
    borderRadius:'3px'
  },

  load:{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
    },
    loadingIcon:{
      color:'#007235',
      fontSize:'50px',
      animation:'$loadSpin 5s infinite'
    },
    "@keyframes loadSpin":{
      from: { transform:'rotate(0deg)' },
      to: { transform:'rotate(1turn)' }
    },
  
  }));

const SmsBasic = () => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const [errSnack, setErrSnack] = useState(false);
    const [succSnack, setSuccSnack] = useState(false);

    const [accessKey, setAccessKey] = useState('')
    const [secretKey, setSecretKey] = useState('')
    const [serviceId, setServiceId] = useState('')
    const [sendHp, setSendHp] = useState('')

    const [smsSubj, setSmssubj] = useState('')
    const [smsCont, setSmsCont] = useState('')

    const [loading, setLoading] = useState(false);
    const [loadingItm, setLoadingItm] = useState(false)


    const getItem = async() => {
        try {
            setLoadingItm(true)
            const res = await axios.post('/api/adm/getSmsInfo/')

            if(res.data.success === false) {
                setErrSnack(true)
                setLoadingItm(false)
                return;
            }
            setAccessKey(res.data.result['accessKey'])
            setSecretKey(res.data.result['secretKey'])
            setServiceId(res.data.result['serviceId'])
            setSendHp(res.data.result['sendHp'])
            setLoadingItm(false)
        
        } catch (e) {
            setLoadingItm(false)
            setErrSnack(true)
            console.log(e)
          }
    }

    useEffect(() => {
      window.scrollTo(0, 0);
      getItem()

      return () => {
        setAccessKey('')
        setSecretKey('')
        setServiceId('')
        setSendHp('')
        setSmssubj('')
        setSmsCont('')
      }
    } ,[])

    const editSmsInfo = async() => {
        if(accessKey === '' || secretKey === '' || serviceId === '' || sendHp === '' ) return;

        setLoading(true)
        try {
            const res = await axios.post('/api/adm/editSmsInfo/', {access_key: accessKey, secret_key: secretKey, serviceId: serviceId, fromHp: sendHp})

            if(res.data.success === false) {
                setErrSnack(true)
                setLoading(false)
                return;
            }
            setSuccSnack(true)
        
        } catch (e) {
            console.log(e)
        }
        setLoading(false)
    }

    const senedSms = async() => {
        if(smsCont === '' || smsSubj === '') return;

        try {
            const res = await axios.post('/api/adm/sendSms/', {sms_subject: smsSubj, sms_content: smsCont})

            if(res.data.success === false) {
                setErrSnack(true)
                return;
            }
            setSuccSnack(true)
        
        } catch (e) {
            console.log(e)
          }
    }


    const snackClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setErrSnack(false);
        setSuccSnack(false)
      };

  return (
    <div className={classes.smsBasicBlock}>
      <div className={classes.box}>
        <h1 className={classes.smsBasicBlockH1}>
          sms기본 (네이버 SMS)
          <div
              onClick={() => {
                setAccessKey('')
                setSecretKey('')
                setServiceId('')
                setSendHp('')
                setSmssubj('')
                setSmsCont('')
                getItem()
              }}
            style={{cursor:'pointer'}}
          >
            <MdOutlineRefresh/>
          </div>
        </h1>
        <div>
          {loadingItm ? (
              <div className={classes.load}>
                <TbLoader className={classes.loadingIcon}/>
              </div>
            ) : (
              <>
              <div className={classes.innerDiv}>
                  <span className={classes.spanSpan}>accessKey</span>
                  <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      variant="outlined"
                      sx={{ width: '250px' }}
                      value={accessKey}
                      onChange={(e) => setAccessKey(e.target.value)}
                  />
              </div>
              <div className={classes.innerDiv}>
                  <span className={classes.spanSpan}>secretKey</span>
                  <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      variant="outlined"
                      sx={{ width: '250px' }}
                      value={secretKey}
                      onChange={(e) => setSecretKey(e.target.value)}
                  />
              </div>
              <div className={classes.innerDiv}>
                  <span className={classes.spanSpan}>serviceId</span>
                  <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      variant="outlined"
                      sx={{ width: '250px' }}
                      value={serviceId}
                      onChange={(e) => setServiceId(e.target.value)}
                  />
              </div>
              <div className={classes.innerDiv}>
                  <span className={classes.spanSpan}>sendHp</span>
                  <div >
                    <TextField
                        hiddenLabel
                        id="filled-hidden-label-small"
                        variant="outlined"
                        sx={{ width: '250px' }}
                        value={sendHp}
                        onChange={(e) => setSendHp(e.target.value)}
                    />
                  </div>
              </div>
              <div className={classes.btnDiv}>
                <Button 
                    variant="outlined"
                    onClick={editSmsInfo}
                >
                    수정
                </Button>
              </div>
              </>
            )}
          
  
        </div>
  
        <div>
          <h1 className={classes.secondH1}>SMS전송 (메세지 수신에 동의한 회원에게 작성한 SMS를 보냅니다.)</h1>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>제목</span>
            <TextField
                hiddenLabel
                id="filled-hidden-label-small"
                variant="outlined"
                sx={{ width: '250px' }}
                value={smsSubj}
                onChange={(e) => setSmssubj(e.target.value)}
            />
          </div>
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>내용</span>
            <textarea                 
                value={smsCont}
                onChange={(e) => setSmsCont(e.target.value)}
                className={classes.formTextarea}
            />
          </div>
  
  
          <div className={classes.btnDiv}>
            {loading ? 
                <CircularProgress /> : 
                (<Button 
                    variant="outlined"
                    style={{ margin:'0 0 20px 0'}}
                >
                    전송
                </Button>)
            }
          </div>
        </div>
  
        <Snackbar 
          open={errSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="error">수행을 실패 하였습니다!</Alert>
        </Snackbar>
        <Snackbar 
          open={succSnack} 
          autoHideDuration={6000} 
          onClose={snackClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
        >
          <Alert severity="success">수행을 성공 하였습니다!</Alert>
        </Snackbar>
      </div> 

    </div>
  )
}

export default SmsBasic
